const currentShell = (state = {}, action) => {
    switch (action.type) {
        case 'SET_BOTH_SHELL':
            return {
                ...state,
                leftShell: action.payload,
                rightShell: action.payload
            };
        case 'SET_LEFT_SHELL':
            return {
                ...state,
                leftShell: action.payload
            };
        case 'SET_RIGHT_SHELL':
            return {
                ...state,
                rightShell: action.payload
            };
        default:
            return state;
    }
};

export default currentShell;
